// @ts-nocheck
export * from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import { CountryModel } from "@insite/client-framework/Types/ApiModels";

export function getAllowedCountries(state: ApplicationState) {
    const allowedShippingCountryCodes =
        getSettingsCollection(state).customSettings.allowedShippingCountryCodes?.split(",");

    if (!allowedShippingCountryCodes?.length) {
        return getCurrentCountries(state);
    }

    return getCurrentCountries(state)?.reduce((result, country) => {
        return allowedShippingCountryCodes.includes(country.abbreviation) ? [...result, country] : result;
    }, [] as CountryModel[]);
}

export function isCountryAllowed(country: CountryModel | null | undefined, state: ApplicationState) {
    if (!country) {
        return true;
    }

    const allowedShippingCountryCodes =
        getSettingsCollection(state).customSettings.allowedShippingCountryCodes?.split(",");

    if (!allowedShippingCountryCodes?.length) {
        return true;
    }

    return allowedShippingCountryCodes.includes(country.abbreviation);
}
